import { readLocalStorageData, saveLocalStorageData } from '@app/services/localStorage.service';
import { LocalStorageItems } from '@app/shared/constants/localStorageItems';
import { IWalletItem } from '@interfaces/FW/Wallets';
import { PrepareAction, createAction, createSlice } from '@reduxjs/toolkit';

interface AccountSlice {
	currentAccount: IWalletItem | null;
}

const initialState: AccountSlice = {
	currentAccount: readLocalStorageData(LocalStorageItems.currentAccount),
};

export const setCurrentAccount = createAction<PrepareAction<IWalletItem>>(
	'account/setCurrentAccount',
	(newAccount) => {
		saveLocalStorageData(LocalStorageItems.currentAccount, newAccount);
		return { payload: newAccount };
	},
);

const accountSlice = createSlice({
	name: 'account',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(setCurrentAccount, (state, action) => {
			state.currentAccount = action.payload;
		});
	},
});

export default accountSlice.reducer;
